import React from 'react';
import { Card } from 'react-bootstrap';
import moment from 'moment';
import { formatCurrency } from '../../helpers/global';

const BATCH_STATS = [
  {
    label: 'INVOICES',
    getValue: batch => batch.invoiceCount,
    valueClassName: 'text-muted'
  },
  {
    label: 'HARD COSTS',
    getValue: batch => formatCurrency(batch.totalHardCost),
    valueClassName: 'text-danger'
  },
  {
    label: 'COLLECTED',
    getValue: batch => formatCurrency(batch.totalCollectedFee),
    valueClassName: 'text-success'
  }
];

const ReconciliationHistoryCard = ({ batch, expanded, onClick }) => {
  const reconciledDate = moment(batch.reconciledAt).format('MM/DD/YYYY') || 'N/A';

  return (
    <Card
      className={`${
        expanded ? 'border-success' : 'border'
      } hover-border-success shadow-sm bg-white rounded-lg p-4 cursor-pointer transition-all duration-200`}
      onClick={onClick}
    >
      <Card.Body className="p-0">
        <div className="d-flex justify-content-between mb-2" style={{ gap: 4 }}>
          {BATCH_STATS.map(({ label, getValue, valueClassName }) => (
            <div key={label} className="text-center">
              <div className="xtinyFont text-muted">{label}</div>
              <div className={`largeFont font-weight-bold ${valueClassName}`}>{getValue(batch)}</div>
            </div>
          ))}
        </div>

        <div className="d-flex align-items-center justify-content-between border-top tinyFont pt-2 text-muted">
          <div>
            Reconciled by <span className="font-weight-bold">{batch.reconciledBy || 'N/A'}</span>
          </div>
          <div>{reconciledDate}</div>
        </div>
      </Card.Body>
    </Card>
  );
};

export const ReconciliationHistoryCardSkeleton = ({ cardCount = 3 }) => {
  return (
    <div className="d-flex" style={{ gap: 16 }}>
      {Array.from({ length: cardCount }, (_, index) => (
        <Card key={index} className="border shadow-sm bg-white rounded-lg p-4 flex-shrink-0" style={{ width: 320 }}>
          <Card.Body className="p-0">
            <div className="d-flex justify-content-between mb-2" style={{ gap: 4 }}>
              {[{ label: 'INVOICES' }, { label: 'HARD COSTS' }, { label: 'COLLECTED' }].map(i => (
                <div key={i.label} className="text-center" style={{ flex: 1, width: '100%' }}>
                  <div className="xtinyFont text-muted mb-2">{i.label}</div>
                  <div
                    className="shimmer"
                    style={{ height: '12px', width: '70px', margin: '0 auto', borderRadius: '4px' }}
                  />
                </div>
              ))}
            </div>

            <div className="d-flex align-items-center justify-content-between border-top pt-2">
              <div className="shimmer" style={{ height: '12px', width: '140px', borderRadius: '4px' }} />
              <div className="shimmer" style={{ height: '12px', width: '80px', borderRadius: '4px' }} />
            </div>
          </Card.Body>
        </Card>
      ))}
    </div>
  );
};

export default ReconciliationHistoryCard;
